module.exports = __webpack_public_path__ + "static/media/cerrajero.2d26235a.png";